import { PersonType } from './../../components/providers/ActivationObjectProvider/types/index'
export enum PackageType {
    'Empty' = 'Nevybráno',
    'BaseProtection' = 'Základní ochrana',
    'StandardProtection' = 'Běžná ochrana',
    'FullProtection' = 'Celková ochrana',
    'ContactLater' = 'Kontaktovat později',
}

export interface ServicePackages {
    packageType: keyof typeof PackageType
    protectedCall24: boolean
    departureRescueUnitDisruption: string
    departureRescueUnitUnDisruption: string
    alarmSettingInMyJablotron: true
    isPossibleHandoverKeys: true
    costMonth: string
    costForNonStandartObject: string
    totalCost: string
}

export interface PackagesData {
    type: PersonType
    data: ServicePackages[]
}
